import type { UserNotification } from "./types";
import { isActiveStatus } from "./types";

/**
 * Per-`kind` presentation hooks. Producers stay generic on the wire; a kind
 * registers here (see ./kinds) only when it wants something better than the
 * defaults: a computed title, a route to open, or to keep transient events
 * (e.g. "working") out of the bell.
 */
export interface NotificationKindConfig {
  /** Show this notification in the bell list. Default: not while active. */
  listed?: (n: UserNotification) => boolean;
  title?: (n: UserNotification) => string;
  message?: (n: UserNotification) => string | null;
  link?: (n: UserNotification) => string | null;
}

const kinds = new Map<string, NotificationKindConfig>();

export function registerNotificationKind(
  kind: string,
  config: NotificationKindConfig,
): void {
  kinds.set(kind, config);
}

export function isListed(n: UserNotification): boolean {
  const listed = kinds.get(n.kind)?.listed;
  return listed ? listed(n) : !isActiveStatus(n.status);
}

export interface NotificationPresentation {
  title: string;
  message: string | null;
  link: string | null;
}

export function presentNotification(
  n: UserNotification,
): NotificationPresentation {
  const cfg = kinds.get(n.kind);
  return {
    title: cfg?.title?.(n) ?? n.title ?? n.kind.replace(/_/g, " "),
    message: cfg?.message ? cfg.message(n) : n.message,
    link: cfg?.link ? cfg.link(n) : n.link,
  };
}

/** Test seam. */
export function _resetNotificationKinds(): void {
  kinds.clear();
}
